import firebase from 'firebase/compat/app';
import { Environment } from '../Environment';

// https://console.firebase.google.com/u/0/project/nerva-dev/overview
const DEVELOPMENT_CONFIG = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGIN_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
};

// https://console.firebase.google.com/u/0/project/ibs-app-d4d2a/overview
const PRODUCTION_CONFIG = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGIN_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

export function initialiseFirebase(): void {
  if (firebase.apps.length === 0) {
    firebase.initializeApp(Environment.isProduction() ? PRODUCTION_CONFIG : DEVELOPMENT_CONFIG);
  }
}
